import { Button, IconButton } from '@sweep-io/sweep-design';
import useAgentsHome from './useAgentsHome';
import RestrictedTooltip from '../common/permissions/RestrictedTooltip';
import usePermission from '../common/permissions/usePermission';
import { Plus } from '@sweep-io/sweep-design/dist/icons';
import useSendBiEvent from '../../hooks/useSendBiEvent';
import { AI_AGENTS_EVENTS } from '../../services/events';
import useIsAgentEnabled from './useIsAgentEnabled';
import usePaywall from '../dashboard/paywall/usePaywall';
import { AgentType } from '@server/ai';

const AiProcessAgentCreateButton = ({
  asIcon,
  disabled,
}: {
  asIcon?: boolean;
  disabled?: boolean;
}) => {
  const permissionStr = 'create:ai-agent';
  const [isAllowedBtn] = usePermission([permissionStr]);
  const { setIsAgentCreateActive, closeAgentsPanel, isOpened, isCreateAgentActive } =
    useAgentsHome();
  const sendBiEvent = useSendBiEvent();
  const isProcessAgentEnabled = useIsAgentEnabled(AgentType.ProcessOptimization);
  const { isPaywallActive } = usePaywall();

  const onClick = () => {
    if (isOpened) {
      closeAgentsPanel();
    }
    if (!isCreateAgentActive) {
      sendBiEvent({
        name: AI_AGENTS_EVENTS.newAgentClick,
        props: { origin: 'button', app: 'canvas' },
      });
    }
    setIsAgentCreateActive(!isCreateAgentActive);
  };

  if (isPaywallActive || !isProcessAgentEnabled) {
    return null;
  }

  const button = asIcon ? (
    <IconButton
      disabled={!isAllowedBtn || disabled}
      variant="system"
      size="small"
      onClick={onClick}
      pressed={isCreateAgentActive}
    >
      <Plus size="medium" />
    </IconButton>
  ) : (
    <Button
      disabled={!isAllowedBtn || disabled}
      variant="system"
      size="small"
      onClick={onClick}
      startIconName="Plus"
      pressed={isCreateAgentActive}
    >
      New Agent
    </Button>
  );

  return (
    <RestrictedTooltip
      to={[permissionStr]}
      notAllowedTitle={'To create an agent, please contact your admin.'}
      allowedTitle={asIcon ? 'Create new agent' : ''}
      placement="bottom"
    >
      {button}
    </RestrictedTooltip>
  );
};

export default AiProcessAgentCreateButton;
